function getDefaultState() {
  return {
    summary: [],
    list: [],
    detail: {},
    formatMoneyList: [
      'subtotal',
      'promotion',
      'adjustment',
      'delivery_fee',
      'tip',
      'sales',
      'invoice_net_sales',
      'invoice_commission_fee',
      'invoice_delivery_fee',
      'invoice_royalty_fee',
      'invoice_takeout_fee',
      'invoice_card_processing_fee',
      'invoice_adjustment',
      'invoice_total',
      'net_profit'
    ],
    formatDistanceList: ['eater_distance']
  }
}
import axios from 'axios'
import ElementUI from 'element-ui'
export default {
  namespaced: true,
  state: {
    summary: [],
    list: [],
    detail: {},
    formatMoneyList: [
      'subtotal',
      'promotion',
      'adjustment',
      'delivery_fee',
      'tip',
      'sales',
      'invoice_net_sales',
      'invoice_commission_fee',
      'invoice_delivery_fee',
      'invoice_royalty_fee',
      'invoice_takeout_fee',
      'invoice_card_processing_fee',
      'invoice_adjustment',
      'invoice_total',
      'net_profit'
    ],
    formatDistanceList: ['eater_distance']
  },
  getters: {
    summary(state) {
      let dispSummary = state.summary
      if ((dispSummary ?? []).length === 0) {
        return []
      }
      dispSummary.forEach((item) => {
        state.formatMoneyList.forEach((key) => {
          item[key] = '¥' + (item[key] || 0).toLocaleString()
        })
      })
      return dispSummary
    },
    list(state) {
      let dispList = state.list
      if ((dispList ?? []).length === 0) {
        return []
      }
      dispList.forEach((item) => {
        state.formatMoneyList.forEach((key) => {
          item[key] = '¥' + (item[key] || 0).toLocaleString()
        })
        if (item.is_cancelled == true) {
          item.status = 'キャンセル'
        } else {
          item.status = '完了'
        }
      })
      return dispList
    },
    detail(state) {
      let dispList = state.detail
      state.formatMoneyList.forEach((item) => {
        dispList[item] = '¥' + (dispList[item] || 0).toLocaleString()
      })
      state.formatDistanceList.forEach((item) => {
        dispList[item] = dispList[item] + 'm'
      })
      if (dispList.is_cancelled == true) {
        dispList.status = 'キャンセル'
      } else {
        dispList.status = '完了'
      }
      if (dispList.invoice_note == '') {
        dispList.invoice_note = '-'
      }
      if (dispList.checkout_type == '') {
        dispList.checkout_type = '-'
      }
      return dispList
    }
  },
  mutations: {
    setOrderSummary(state, data) {
      state.list = data.list
      state.summary = data.summary
    },
    setOrderDetail(state, data) {
      state.detail = data
    },
    resetOrderDetail(state) {
      state.detail = {}
    },
    clearState(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async getOrderSummary({ commit }, data) {
      const req = require('querystring').stringify(data)
      const title = navigator.language === 'ja' ? '結果' : 'Result'
      const message = navigator.language === 'ja' ? '該当する売上情報がありません' : 'No Result'
      await axios
        .get('/orders/summary?' + req)
        .then((response) => {
          if ((response.data.data ?? []).length === 0) {
            ElementUI.MessageBox.alert(message, title, { dangerouslyUseHTMLString: false, confirmButtonText: 'OK' })
          }
          commit('setOrderSummary', response.data.data)
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    async getOrderDetail({ commit }, uuid) {
      commit('resetOrderDetail')
      await axios
        .get('/orders?uuid=' + uuid)
        .then((response) => {
          commit('setOrderDetail', response.data.data)
        })
        .catch((error) => {
          console.log('catch : error :' + error)
        })
    },
    clearState({ commit }) {
      commit('clearState')
    }
  }
}
